<template>
  <v-app light>
    <v-content style="background: white;">
      <v-slide-y-transition mode="out-in">
        <keep-alive>
          <router-view></router-view>
        </keep-alive>
      </v-slide-y-transition>
    </v-content>
  </v-app>
</template>

<script>
import dbdata from './assets/dbdata.json';

export default {
  data: () => ({
  }),
  created() {
    this.$store.dispatch('fetchTkData')
  },
}

</script>


// WEBPACK FOOTER //
// src/App.vue